import DashEvents from 'screens/dashboard/DashEvents';
import paths from './paths';
import DashProfile from 'screens/dashboard/DashProfile';
import DashSupport from 'screens/dashboard/DashSupport';
import DashFinancial from 'screens/dashboard/DashFinancial';
import DashCheckin from 'screens/dashboard/DashCheckin';
import DashProducts from 'screens/dashboard/DashProducts';
import DashOrders from 'screens/dashboard/DashOrders';
import DashEstablishmentOrders from 'screens/dashboard/DashEstablishmentOrders';
import DashStatistics from 'screens/dashboard/DashStatistics';
import DashRestaurantMenu from 'screens/dashboard/DashRestaurantMenu';
import DashRestaurantKitchen from 'screens/dashboard/DashRestaurantKitchen';
import DashRestaurantWaiter from 'screens/dashboard/DashRestaurantWaiter';
import DashRestaurantAdmin from 'screens/dashboard/DashRestaurantAdmin';
import DashRestaurantStatistics from 'screens/dashboard/DashRestaurantStatistics';
import DashRestaurantCashier from 'screens/dashboard/DashRestaurantCashier';
import DashRestaurantPosEvents from 'screens/dashboard/DashRestaurantPosEvents';

export default [
    // {
    //     exact: true,
    //     path: paths.dashboard.resume,
    //     element: <DashResume />
    // },
    {
        exact: true,
        path: paths.dashboard.events,
        element: <DashEvents />
    },
    {
        exact: true,
        path: paths.dashboard.products,
        element: <DashProducts />
    },
    {
        exact: true,
        path: paths.dashboard.home,
        element: <DashProfile />
    },
    {
        exact: true,
        path: paths.dashboard.financial,
        element: <DashFinancial />
    },
    {
        exact: true,
        path: paths.dashboard.checkin,
        element: <DashCheckin />
    },
    {
        exact: true,
        path: paths.dashboard.support,
        element: <DashSupport />
    },
    {
        exact: true,
        path: paths.dashboard.orders,
        element: <DashOrders />
    },
    {
        exact: true,
        path: paths.dashboard.orders_establishment,
        element: <DashEstablishmentOrders />
    },
    {
        exact: true,
        path: paths.dashboard.statistics,
        element: <DashStatistics />
        // element: <DashResume />
    },
    { exact: true, path: paths.dashboard.restaurant.menu,       element: <DashRestaurantMenu /> },
    { exact: true, path: paths.dashboard.restaurant.posEvents,  element: <DashRestaurantPosEvents /> },
    { exact: true, path: paths.dashboard.restaurant.kitchen,    element: <DashRestaurantKitchen /> },
    { exact: true, path: paths.dashboard.restaurant.waiter,     element: <DashRestaurantWaiter /> },
    { exact: true, path: paths.dashboard.restaurant.admin,      element: <DashRestaurantAdmin /> },
    { exact: true, path: paths.dashboard.restaurant.statistics, element: <DashRestaurantStatistics /> },
    { exact: true, path: paths.dashboard.restaurant.cashier,    element: <DashRestaurantCashier /> },
]